import { MULTILANGUAGEGQLSCHEMA } from "./MultiLanguage";

export const BETTINGWEBSITELANGUAGEGQLSCHEMA = `
id
Country{
    ${MULTILANGUAGEGQLSCHEMA}
}
Flag
`;
